<template>
  <div class="sidebar-widget single-content-widget" v-if="sail != null">
      <div class="sidebar-widget-item">
        <div class="sidebar-book-title-wrap mb-3">
          <h3>Rezervasyon Detayları</h3>
        </div>
      </div>
      <div class="form-content p-0">
        <div class="card-item shadow-none radius-none mb-0">
          <div class="card-img pb-4">
            <a href="javascript:void(0)" class="d-block">
              <img :src="sail.seaTour.imageUrl" height="150px">
            </a>
          </div>
          <div class="card-body p-0">
            <div class="d-flex justify-content-between">
              <div>
                <h3 class="card-title">{{ sail.cruise.name }}</h3>
                <p class="card-meta" v-if="sail.routes != null && sail.routes.length > 0">{{ sail.routes[0].port.name }}</p>
              </div>
            </div>
            <div class="section-block"></div>
            <ul class="list-items list-items-2 list-items-flush py-2 list-items-my" v-if="sail.routes != null && sail.routes.length > 0">
              <li class="font-size-15">
                <span class="w-auto d-block mb-n1">
                  <i class="la la-ship mr-1 text-black font-size-17"></i>Kalkış
                </span>
                {{sail.routes[0].departureDate | ddMMyyyyHHmm }}
              </li>
              <li class="font-size-15">
                <span class="w-auto d-block mb-n1">
                  <i class="la la-ship mr-1 text-black font-size-17"></i>Dönüş
                </span>
                {{sail.routes[sail.routes.length-1].arrivalDate | ddMMyyyyHHmm }}
              </li>
            </ul>
            <div class="section-block"></div>
            <ul class="list-items list-items-2 py-3 list-items-my">
              <li><span>Sefer Adı:</span><div>{{ sail.cruise.name }}</div></li>
              <li v-if="cabinListText != '' && cabinListText != ''"><span>Kabin Tipi:</span>{{cabinListText}}</li>
              <li v-if="passengers.length > 0"><span>Yolcu Sayısı:</span>{{passengers.length}}</li>
            </ul>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "bookingSidebar",
  props:{
    bookNow:Function,
    propBooking : Object,
  },
  computed:{
    sail:{
      get(){
        return this.propBooking.sail;
      }
    },
    totalPrice:{
      get(){
        return this.propBooking.totalPrice;
      }
    },
    contactPhone : {
      get(){
        return this.$store.getters.getContactPhone;
      }
    },
    contactEmail : {
      get(){
        return this.$store.getters.getContactEmail;
      }
    },
    contactName : {
      get(){
        return this.$store.getters.getContactName;
      },
      set(value){
        this.$store.commit("setContactName",value);
      }
    },
    paxHtml : {
      get(){
        let text = "";
        if(this.adultCount>0){
          text = text + " " + this.adultCount + " Yetişkin<br>"
        }
        if(this.childCount>0){
          text = text + " " + this.childCount + " Genç<br>"
        }
        if(this.infantCount>0){
          text = text + " " + this.infantCount + " Bebek<br>"
        }

        return text;
      }
    },
    canPost : {
      get(){
        return this.$store.getters.getCanPost;
      }
    },
    selectedCruiseCabins : {
      get(){
        return this.$store.getters.getSelectedCruiseCabins;
      },
    },
    passengers: {
      get() {
        if(this.propBooking != null){
          return this.propBooking.bookingPassengers;
        }
        return this.$store.getters.getPassengers;
      }
    },
    booking : {
      get(){
        if(this.propBooking != null){
          return this.propBooking;
        }
        return this.$store.getters.getBooking
      }
    },
    myCruiseRoomIdCabin : {
      get(){
        let sail = this.sail
        sail.organizedCruiseRooms = {};
        //Group by cabinType
        let map = {}
        for(let i=0;i<sail.rooms.length;i++) {
          for(let j=0;j<sail.rooms[i].cruiseRooms.length;j++){
            map[sail.rooms[i].cruiseRooms[j].id] = sail.rooms[i].cabinType
          }
        }
        return map
      }
    },
    cabinListText : {
      get(){
          let array = [];
          if(this.booking != null){
            if(this.booking.bookingRooms != null){
              for(let i=0;i<this.booking.bookingRooms.length;i++){
                let name = this.myCruiseRoomIdCabin[this.booking.bookingRooms[i].cruiseRoomId].name
                if(!array.includes(name)){
                  array.push(name)
                }
              }
            }else {
              for(let i=0;i<this.passengers.length;i++){
                if(this.passengers[i].cruiseRoomId != null){
                  let name = this.myCruiseRoomIdCabin[this.passengers[i].cruiseRoomId].name
                  if(!array.includes(name)){
                    array.push(name)
                  }
                }
              }
            }
          }

          return array.toString();
      }
    }
  },
  methods:{
    bookNowClick(){
      this.bookNow();
    }
  }
}
</script>

<style scoped>

</style>